export default __webpack_public_path__ + "imgs/386bed1a3a74436f356aea53859a7280.png";